export var defaultMonthOptions = {
    width: 7,
    height: 6
};
//# sourceMappingURL=_defaults.js.map


//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/ngx-bootstrap/datepicker/reducer/_defaults.js
// module id = ../../../../ngx-bootstrap/datepicker/reducer/_defaults.js
// module chunks = 5